export default __webpack_public_path__ + "static/7-5c9cbcad4d450105852418227b35d57b.webp";